import { component } from 'picoapp';

export default component((node, ctx) => {
  const links = node.querySelectorAll('a');
  links.forEach(link => {
    if (window.location.href == link.href) {
      link.classList.add('is-active');
      console.log('offsetLeft', link.offsetLeft);
      node.scrollLeft = link.offsetLeft - 20;
    }
  });
});
